import React, { useState } from "react";
import { Minus, Plus, Trash } from "lucide-react";
import { Button } from "src/components/ui/button";
import Footer from "src/components/Footer";
import Navbar from "src/components/Navbar";
import { pendingbooking } from "src/assets/images";
import SimilarProducts from "src/components/ProductCategories/SimilarProducts";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";


const PendingBookings = () => {
    const { conversionRates } = useProtectedRoutesContext()
    const [bookings, setBookings] = useState([
        { id: 1, image: pendingbooking, title: "Product 1", price: 50, quantity: 1, selected: false },
        { id: 2, image: pendingbooking, title: "Product 2", price: 80, quantity: 1, selected: false },
        { id: 3, image: pendingbooking, title: "Product 3", price: 100, quantity: 1, selected: false },
    ]);

    const toggleSelect = (id) => {
        setBookings((prev) =>
            prev.map((booking) =>
                booking.id === id ? { ...booking, selected: !booking.selected } : booking
            )
        );
    };

    const changeQuantity = (id, delta) => {
        setBookings((prev) =>
            prev.map((booking) =>
                booking.id === id
                    ? { ...booking, quantity: Math.max(1, booking.quantity + delta) }
                    : booking
            )
        );
    };

    const deleteBooking = (id) => {
        setBookings((prev) => prev.filter((booking) => booking.id !== id));
    };

    return (
        <>
            <Navbar />
            <div className="container mx-auto py-10">
                <h1 className="text-2xl font-bold mb-6">Pending Bookings</h1>
                <div className="grid grid-cols-10 gap-4  p-4 rounded-md font-semibold pending-fatix-booking-div">
                    <div className="col-span-2 text-center">Select All</div>
                    <div className="col-span-2 text-center">Product</div>
                    <div className="col-span-2 text-center">Quantity</div>
                    <div className="col-span-2 text-center">Total</div>
                    <div className="col-span-2 text-center">Action</div>
                </div>

                {bookings.map((booking) => (
                    <div key={booking.id} className="grid grid-cols-10 items-center gap-4 p-4 border-b pending-fatix-booking-div">
                        {/* Select Checkbox */}
                        <div className="col-span-2 flex justify-center">
                            <button
                                className={`w-6 h-6 flex items-center justify-center border rounded ${booking.selected ? "bg-blue-500 text-white" : "border-gray-400"}`}
                                onClick={() => toggleSelect(booking.id)}
                            >
                                {booking.selected && "✔"}
                            </button>
                        </div>

                        {/* Product Image & Title */}
                        <div className="col-span-2 flex flex-col items-center">
                            <img src={booking.image} alt={booking.title} className="w-[120px] h-[200px] rounded-md object-cover pending-fatix-booking-div-img" />
                        </div>

                        {/* Quantity Selector */}
                        <div className="col-span-2 flex justify-center items-center space-x-2">
                            <Button variant="outline" onClick={() => changeQuantity(booking.id, -1)}>
                                <Minus />
                            </Button>
                            <span className="text-lg">{booking.quantity}</span>
                            <Button variant="outline" onClick={() => changeQuantity(booking.id, 1)}>
                                <Plus />
                            </Button>
                            <Button variant="destructive" onClick={() => deleteBooking(booking.id)}>
                                <Trash />
                            </Button>
                        </div>

                        {/* Total Price */}
                        <div className="col-span-2 text-center font-semibold">₦{booking.price * booking.quantity * conversionRates[booking?.materialId]}</div>

                        {/* Pay Now Button */}
                        <div className="col-span-2 flex justify-center">
                            <a className="bg-green-600 text-white pay-now-button" href="1">Pay Now</a>
                        </div>
                    </div>
                ))}
            </div>
            <div className=" container checkout-all-items">
                <a className="" href="1">Continue Shopping</a>
                <a className="checkout-now-button" href="1">Checkout all Items</a>
            </div>
            <div className="container">
                <h1 className="consider-header mb-[20px] mt-[70px] also-consider-header">Also Consider</h1>
                <SimilarProducts />
            </div>
            <Footer />
        </>
    );
};

export default PendingBookings;
